import { Box, Typography, TypographyProps } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid";

export const tableTextStyles = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "1.33", // 16px / 12px → 1.33
};

interface TextCellProps extends GridRenderCellParams<any, string | number> {
  TypographyProps?: TypographyProps;
}

export function TextCell(params: TextCellProps) {
  const { value, TypographyProps } = params;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
      }}
    >
      <Typography
        sx={{
          ...tableTextStyles,
          letterSpacing: "0.48px",
          width: "100%",
          ...TypographyProps?.sx,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}
